<template>
  <button class="rounded p-4 flex items-center justify-center space-x-1" :class="buttonClasses.length > 1 ? buttonClasses : 'bg-primary text-white text-base' " :style="styleOverride">
      <span class="block">{{ text }}</span>
      <img :src="icon" alt="" v-if="icon" class="h-7">
  </button>
</template>

<script>
export default {
  name: "Button",
  props: [
    'buttonClasses', 'text', 'icon',
    'styleOverride'
  ]
};
</script>

<style>
</style>